import { createSlice } from "@reduxjs/toolkit";
import { accountDetailAPI, userProfileStateAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
  userState:null
};

const accountDetailSlice = createSlice({
  name: "accountDetail",
  initialState: data,
  reducers: {
    accountDetailSlice(state) {
      state.isLoading = false;
    },
    accountDetailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    userProfileStatesSliceSuccess(state, action) {
      state.isLoading = false;
      state.userState = action.payload;
      state.message = null;
    },
    accountDetailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    accountDetailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const accountDetailHandler = (user_id:string) => async (dispatch: any) => {
  try {
    dispatch(accountDetailAction.accountDetailSlice());
    const response: any = await accountDetailAPI(user_id);
    dispatch(accountDetailAction.accountDetailSliceSuccess(response.results));
  } catch (e: any) {
    dispatch(accountDetailAction.accountDetailSliceFailure(e?.response?.data?.message));
    dispatch(accountDetailAction.accountDetailSliceReset());
  }
};
export const userProfileStatesHandler = (user_id:string) => async (dispatch: any) => {
  try {
    dispatch(accountDetailAction.accountDetailSlice());
    const response: any = await userProfileStateAPI(user_id);
    dispatch(accountDetailAction.userProfileStatesSliceSuccess(response));
  } catch (e: any) {
    dispatch(accountDetailAction.accountDetailSliceFailure(e?.response?.data?.message));
    dispatch(accountDetailAction.accountDetailSliceReset());
  }
};
export default accountDetailSlice.reducer;
export const accountDetailAction = accountDetailSlice.actions;
